import * as React from 'react';
import { scrollToAnchor } from '@cian/newbuilding-utils';
import { useSelector } from 'react-redux';

import { LabelsLayout, BuilderStatus } from '../../components/Labels';
import { EscrowLabel } from '../../components/Labels/EscrowLabel';
import { EscrowLabelTooltip } from '../../components/Labels/EscrowLabelTooltip';
import { ReliableLabelTooltip } from '../../components/Labels/ReliableLabelTooltip';
import { isReliableSelector, getNewbuildingId, isEscrowSelector } from '../../selectors/newbuilding';
import { newbuildingLabelsSelector } from '../../selectors/newbuilding/newbuildingLabels';
import { trackEscrowLabelClick, trackReliableLabelClick, trackReliableLabelHover } from './tracking';

export function LabelsContainer() {
  const isReliable = useSelector(isReliableSelector);
  const isEscrow = useSelector(isEscrowSelector);
  const labels = useSelector(newbuildingLabelsSelector);
  const newbuildingId = useSelector(getNewbuildingId);

  const onReliableLabelHover = React.useCallback(() => {
    trackReliableLabelHover(newbuildingId);
  }, [newbuildingId]);

  const onReliableLabelClick = (event: React.MouseEvent<HTMLElement>) => {
    scrollToAnchor({
      anchor: '#reliable',
      offset: 0,
      hasRelocation: false,
      hasAnimation: true,
    })(event);
    trackReliableLabelClick();
  };

  const onEscrowLabelClick = (event: React.MouseEvent<HTMLElement>) => {
    scrollToAnchor({
      anchor: '#escrow',
      offset: 100,
      hasRelocation: false,
      hasAnimation: true,
    })(event);
    trackEscrowLabelClick();
  };

  return (
    <LabelsLayout>
      {isReliable && <ReliableLabelTooltip onOpen={onReliableLabelHover} onClick={onReliableLabelClick} />}
      {labels.labelText && <BuilderStatus {...labels} />}
      {isEscrow && <EscrowLabelTooltip label={<EscrowLabel onClick={onEscrowLabelClick} />} />}
    </LabelsLayout>
  );
}
